const Avatar = ({ path, svg, className, rounded = false, circle = false }) => {
    return (
        <div className={`avatar ${rounded ? "rounded" : ""} ${circle ? "circle" : ""} ${className ? className : ""}`}>
            {path && <img src={path} />}
            {svg ? svg : null}
        </div>
    );
};

export default Avatar;
